export default "__VITE_ASSET__DqR4$eel__"